export default "__VITE_ASSET__0833ede4__"